import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";
import AppButton from "./AppButton";

const ConfirmDialog = ({
    open,
    title = "Confirm",
    message = "Are you sure?",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    loading = false,
    loadingLabel = "Processing...",
    onConfirm,
    onClose,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1rem" }}>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText sx={{ fontSize: "0.875rem", color: "#374151" }}>
                {message}
            </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
            <AppButton variant="secondary" onClick={onClose} disabled={loading}>{cancelLabel}</AppButton>
            <AppButton variant="fill" onClick={onConfirm} disabled={loading}>{loading ? loadingLabel : confirmLabel}</AppButton>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
